import { eqTimeSlots } from "./equipTime";

 const getJSTRoundedTime = () => {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  const japanTime = new Date(utc + 9 * 60 * 60000);

  const hour = japanTime.getHours();
  const minute = japanTime.getMinutes() < 30 ? 0 : 30;

  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
};

 
export const getLatestEqTimeSlot = () => {
  const formattedTime = getJSTRoundedTime();

  if (eqTimeSlots.includes(formattedTime)) return formattedTime;

  const index = eqTimeSlots.findIndex(t => t > formattedTime);
  return index > 0 ? eqTimeSlots[index - 1] : "00:00";
};

export const getNextEqTimeSlot = () => {
  const formattedTime = getJSTRoundedTime();

  const index = eqTimeSlots.findIndex(t => t > formattedTime);
  return index !== -1 ? eqTimeSlots[index] : "23:30";
};
